/** @jsx jsx */
// @ts-ignore
import React, { useState } from "react";
import { css, jsx } from "@emotion/core";
import TextForm from "components/molecules/TextForm";
import { RecorderButton, PrimaryButton } from "components/atoms/Button";
import FlexBox from "components/atoms/FlexBox";
import FlexBoxItem from "components/atoms/FlexBoxItem";
import { grayScale, customButtonColor } from "components/styles";
import BodyText from "components/atoms/BodyText";
import Modal from "components/molecules/Modal";
import useToastNotification from "hooks/useToastNotification";
import useBarcodeRecorder from "./hooks";
import moment from "moment";
const isIpad = window.matchMedia("(max-width: 1024px)").matches;

const styles = {
  formRecorder: css({
    textAlign: "center",
  }),
  dateForm: css({
    width: `${isIpad ? '100%' : '420px'}`,
    justifyContent: 'center',
    margin: "auto",
  }),
  formContainer: css({
    marginTop: "15px",
    borderRadius: "3px",
    // paddingBottom: isIpad ? "20px" : "50px",
    display: isIpad ? 'flex' : '',
    flexWrap: 'wrap',
    justifyContent: 'center'
  }),
  imageButton: css({
    width: "100%",
    textAlign: 'center',
    height: '80px',
  }), 
  ipadTimeContainer: css({
    display: "flex",
    flexWrap: "wrap",
    alignSelf: "center",
    width: "100%",
    marginLeft: '20px',
    justifyContent: 'center'
  })
};

const inputForm = css`
  width: ${isIpad ? '420px' : '450px'};
  margin: auto;
  margin-bottom: 40px;
  justify-content: space-between;
`;

const timeCss = css`
  align-items: baseline;
  justify-content: space-between;
  margin: auto;
  width: ${isIpad ? 'auto' : '350px'};
  color: red;
  line-height: ${isIpad ? '80px' : '100px'};
  span:first-of-type {
    font-size: ${isIpad ? '64px' : '100px'};
    margin-right: 10px;
    font-weight: bold;
    color: ${grayScale.gray100};
  }
  span:last-of-type {
    font-size: 32px;
    color: ${grayScale.gray100};
  }
`;

const btnContainer = css`
  display: flex;
  flex-wrap: nowrap;
  width: ${isIpad ? '500px' : '700px'};
  justify-content: center;
  margin: 30px auto 30px auto;
  height: auto;
  button {
    border-radius: 3px;
    border: 0;
    height: 120px;
    font-size: 24px;
    height: 120px;
    margin-bottom: 20px;
    margin-left: 30px;
  }
  button:hover {
    opacity: 0.9;
  }
`;

// const tableModal = css`
//   border-collapse: collapse;
//   font-size: 14px;
//   tr th {
//     color: #999999;
//     padding-right: 50px;
//     position: relative;
//     border-right: 1px solid #dcdcdc;
//   }
//   tr:not(:last-child) {
//     th,
//     td {
//       padding-bottom: 35px;
//     }
//   }
//   tr td {
//     padding-left: 30px;
//   }
//   margin: 20px auto;
// `;

const BarcodeRecorder: React.FC<{
  dataTimes: any;
  dataSettings: any;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  disabledRecorder: boolean;
  fetchHistoryData: any;
}> = ({
  dataTimes,
  dataSettings,
  setIsLoading,
  disabledRecorder,
  fetchHistoryData,
}) => {
  const { errorNotification } = useToastNotification();
  const [openModal, setOpenModal] = useState(false);
  const {
    handleSubmitBarcode,
    formik,
    formikConfirm,
    isConfirm,
    staffName,
    lastStampType,
    handleRecorder,
    businessName,
    stampType,
    newUiRemote
  } = useBarcodeRecorder(
    dataSettings.stampOrgCode,
    dataSettings.setStampOrgCode,
    dataSettings.stampOrgName,
    dataSettings.setStampOrgName,
    dataSettings.loginOrgCode,
    dataSettings.setLoginOrgCode,
    dataSettings.loginOrgName,
    dataSettings.setLoginOrgName,
    dataTimes.resultCurrentTime,
    setOpenModal,
    setIsLoading,
    fetchHistoryData
  );
  const handleSubmit = () => {
    if (formik.values.inputBarcodeId) {
      handleSubmitBarcode();
    } else {
      errorNotification("打刻IDを入力してください。");
    }
  };
  const [selectedDay, setSelectedDay] = useState<any>(null);

  return (
    <React.Fragment>
      <div css={styles.formContainer}>
      <div css={isIpad ? styles.ipadTimeContainer : {}}>
          {dataTimes.currentDay ? (
            <React.Fragment>
              <FlexBox customStyle={styles.dateForm}>
                <BodyText size="lg" color={grayScale.gray100} bold={true}>
                  {dataTimes.currentDay}
                </BodyText>
              </FlexBox>
              <FlexBox customStyle={timeCss}>
                <BodyText>{dataTimes.timeNow}</BodyText>
                <BodyText>{dataTimes.second}</BodyText>
              </FlexBox>
            </React.Fragment>
          ) : (
            <div
              style={{
                fontSize: isIpad ? '30px' : '80px',
                textAlign: 'center',
                marginBottom: '20px'
              }}
            >
              サーバ時間取得中・・・
            </div>
          )}
        </div>

        {!isConfirm && (
          <FlexBox customStyle={inputForm}>
            <FlexBoxItem basis="270px">
              <TextForm
                name="inputBarcodeId"
                label=""
                value={formik.values.inputBarcodeId}
                onChange={formik.handleChange}
                placeHolder="IDを入力してください"
              />
            </FlexBoxItem>
            <PrimaryButton
              text="IDを入力"
              onClick={() => handleSubmit()}
              disabled={disabledRecorder}
              minWidth={isIpad ? "120px" : "160px"}
              customStyle={css({ fontWeight: "bold" })}
            />
          </FlexBox>
        )}

        {isConfirm && (
          <div style={{ width: "100%", textAlign: "center" }}>
            <BodyText color={grayScale.gray100} size="xxl" bold={true}>
              {staffName}
              {
                (lastStampType === -1 || lastStampType === 3) && "さん、出勤打刻を押してください。"
              }
              {
                (lastStampType === 0 || lastStampType === 2) && "さん、退勤打刻または休憩開始を押してください。"
              }
              {
                lastStampType === 1 && "さん、休憩終了を押してください。"
              }
            </BodyText>
          </div>
        )}

        {/* <FlexBoxItem basis="48%">
        <PrimaryButton
          text="出勤"
          onClick={() => {}}
          fullwidth={true}
          customStyle={css({
            backgroundColor: customButtonColor.green,
            "&:hover,&:focus": css({
              backgroundColor: customButtonColor.green,
            }),
          })}
        />
      </FlexBoxItem> */}
      
        {isConfirm && (
          <React.Fragment>
            <FlexBox customStyle={btnContainer}>
              {(lastStampType === -1 || lastStampType === 3) && (
                <FlexBoxItem basis="48%">
                  <RecorderButton
                    text="出勤"
                    onClick={() => handleRecorder(0)}
                    icon="checkInOffice"
                    background="#007BC3"
                  />
                </FlexBoxItem>
              )}

              {/* {(lastStampType === -1 || lastStampType === 3) && !newUiRemote && (
                <FlexBoxItem basis="48%">
                  <RecorderButton
                    text="出勤"
                    onClick={() => handleRecorder(0)}
                    icon="checkInOffice"
                    background="#007BC3"
                  />
                </FlexBoxItem>
              )}
              {(lastStampType === -1 || lastStampType === 3) && newUiRemote && (
                <React.Fragment>
                  <FlexBoxItem basis="48%">
                    <RecorderButton
                      text="オフィス出勤"
                      onClick={() => handleRecorder(0)}
                      icon="checkInOffice"
                      background="#007BC3"
                    />
                  </FlexBoxItem>
                  <FlexBoxItem basis="48%">
                    <RecorderButton
                      text="テレワーク出勤"
                      onClick={() => handleRecorder(0, undefined, undefined, true)}
                      icon="checkInRemote"
                      background="#F8BF2D"
                    />
                  </FlexBoxItem>
                </React.Fragment>
              )} */}

              {(lastStampType === 0 || lastStampType === 2) && (
                <FlexBoxItem basis="48%">
                  <RecorderButton
                    text="退勤"
                    onClick={() => handleRecorder(3)}
                    icon="checkOut"
                    background="#666666"
                  />
                </FlexBoxItem>
              )}

              {(lastStampType === 0 || lastStampType === 2) && (
                <RecorderButton
                  text="休憩開始"
                  onClick={() => handleRecorder(1)}
                  icon="breakStart"
                  background="#00B172"
                />
              )}

              {lastStampType === 1 && (
                <FlexBoxItem basis="48%">
                  <RecorderButton
                    text="休憩終了"
                    onClick={() => handleRecorder(2)}
                    icon="breakEnd"
                    background="#8B2E9C"
                  />
                </FlexBoxItem>
              )}
            </FlexBox>
          </React.Fragment>
        )}
      </div>
      {/* <Modal
        open={openModal}
        closeHandler={() => setOpenModal(false)}
        title="打刻完了"
        submitText="閉じる"
        closeText=""
        onSubmit={() => formikConfirm.submitForm()}
        note="以下の内容で打刻しました"
      >
        <table css={tableModal}>
          <tbody>
          <tr>
            <th>氏名</th>
            <td>{formikConfirm.values.staffName}</td>
          </tr>
          <tr>
            <th>日付</th>
            <td>
              {moment(new Date(formikConfirm.values.stampTime)).format(
                "YYYY年MM月DD日 (ddd)"
              )}
            </td>
          </tr>
          <tr>
            <th>時間</th>
            <td>
              {moment(new Date(formikConfirm.values.stampTime)).format(
                "HH:mm:ss"
              )}
            </td>
          </tr>
          <tr>
            <th>打刻</th>
            <td>
              {stampType === 0 && <React.Fragment>出勤</React.Fragment>}
              {stampType === 1 && <React.Fragment>休憩開始</React.Fragment>}
              {stampType === 2 && <React.Fragment>休憩終了</React.Fragment>}
              {stampType === 3 && <React.Fragment>退勤</React.Fragment>}
              {businessName}
            </td>
          </tr>
          </tbody>
        </table>
      </Modal> */}
    </React.Fragment>
  );
};

export default BarcodeRecorder;
